import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';

import {
    MeetingsInfo,
    MeetingsInfoWrapper,
} from 'src/domains/sportsbook/webview/components/meetingsAntePostAndSpecials/Meetings.style';
import { SportRacesTypeParamType } from 'src/domains/layouts/state/router/newRouter/mainRouteTypes';
import { EventId } from 'src_common/common/websocket2/id/WebsocketId';
import {
    getCustomMarketNew,
    groupEvents,
    MeetingsState,
} from 'src/domains/sportsbook/webview/components/meetingsAntePostAndSpecials/MeetingsState';
import { TableSportsList } from 'src/domains/sportsbook/webview/components/meetingsAntePostAndSpecials/MeetingsGroup';
import { MeetingsRaceCard } from 'src/domains/sportsbook/webview/components/meetingsAntePostAndSpecials/MeetingsRaceCard';
import { MeetingsAntePostLoader } from 'src/domains/sportsbook/webview/components/meetings/loaders/MeetingsLoaders';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface PropType {
    eventId: EventId | null;
    filterType: SportRacesTypeParamType | null;
    handleScroll?: () => void;
    isLoading: boolean;
    shared: boolean;
    sport: 'horseracing' | 'greyhoundracing';
}

export const MeetingsAntePost = observer('MeetingsAntePost', (props: PropType) => {
    const { eventId, isLoading, filterType, handleScroll, sport } = props;
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;

    const [state] = React.useState(() => new MeetingsState(common, () => sport));

    const eventsAntePost = state.collectionEventsAntePost;
    const events = groupEvents(eventsAntePost);
    const event = eventId?.getEventModel() ?? null;

    if (isLoading) {
        return (
            <MeetingsInfoWrapper variant={configState.componentVariants.sportsbookVariant}>
                <MeetingsInfo variant={configState.componentVariants.sportsbookVariant}>
                    <MeetingsAntePostLoader />
                </MeetingsInfo>
            </MeetingsInfoWrapper>
        );
    }

    if (eventsAntePost.length === 0) {
        return (
            <MeetingsInfoWrapper variant={configState.componentVariants.sportsbookVariant}>
                <MeetingsInfo variant={configState.componentVariants.sportsbookVariant}>
                    <I18n
                        langKey='events.ante-post.empty'
                        defaultText='There are no races available at the moment. Please check again later.'
                    />
                </MeetingsInfo>
            </MeetingsInfoWrapper>
        );
    }

    const isAntePostEvent = event !== null && event.antePost && filterType === 'ante-post';

    if (isAntePostEvent) {
        const markets = getCustomMarketNew(event);

        return (
            <MeetingsRaceCard
                markets={markets}
                section='ante-post'
            />
        );
    }

    return (
        <TableSportsList
            events={events}
            section='ante-post'
            handleScroll={handleScroll}
        />
    );
});
